import { useState, useEffect, useRef, useContext } from 'react';
import { useSelector } from 'react-redux';
import PageContext from '../sub-components/PageContext';
import HeaderBanner from '../sub-components/HeaderBanner.tsx';
import Footer from "../sub-components/Footer.tsx";
import PageDropdown from '../sub-components/PageDropdownCopy.jsx';
import PageInput from '../sub-components/PageInputCopy.jsx'; 
import ApiDataTable from '../sub-components/ApiDataTable';
import TransactionDataRow from '../sub-components/TransactionDataRow';
import DatePicker from '../sub-components/DatePickerCopy.jsx';
import AutoCompleteInput from '../sub-components/AutoCompleteInputCopy.jsx';
import moment from 'moment'; 
import { HttpContext } from '../../api-services/HttpService';
import AutoCompleteInputWithOptions from '../sub-components/AutoCompleteInputWithOptionsCopy.jsx';
import ExportS3ExcelButton from '../sub-components/ExportS3ExcelButton';
import SnackbarAlert from '../sub-components/SnackbarAlert';
import removeStrCommas from '../functions/removeStrCommas';
import PageBreadcrumbs from '../sub-components/PageBreadcrumbs.jsx'; 
import ButtonComponent from '../sub-components/ButtonComponent.jsx';
import { Typography } from '@mui/material';
import isNullOrUndefined from "../functions/isNullOrUndefined.js"; 
import _ from "lodash";

const TransactionDetailsPage = () =>{ 
    // global redux state for company (passed in from other route)
    const company = useSelector((state) => state.company);
    const companyInfo = useSelector((state) => state.companyInfo);
    const transactionDetails = useSelector((state) => state.transactionDetails);
    // initialize http context 
    const {
        GET,
        GETQ,  
    } = useContext(HttpContext);
    // initialize state
    const [accountInput, setAccountInput] = useState('');
    // const [accountList, setAccountList] = useState(['All']);
    const [subCompanyInput, setSubCompanyInput] = useState('All');
    const [subCompanyList, setSubCompanyList] = useState(['All']);
    const [feeCategorySelected, setFeeCategorySelected] = useState('All');
    const [feeCategoryList, setFeeCategoryList] = useState(['All']);
    const [productType, setProductType] = useState('All');
    const [productTypeList, setProductTypeList] = useState(['All']);
    const [transactionDescription, setTransactionDescription] = useState('');
    const [transactionLow, setTransactionLow] = useState('');
    const [transactionHigh, setTransactionHigh] = useState('');
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    // initialize state for table
    const [dataList, setDataList] = useState([]); 
    const [tableHeader, setTableHeader] = useState([]);
    // initialize state for spinner
    const [showSpinner, setShowSpinner] = useState(false);
    // initialize master company list for dropdown 
    const [masterCompany, setMasterCompany] = useState('--select--');
    const [masterCompanyObj, setMasterCompanyObj] = useState({label: '--select--', id: '--select--'});
    const [dropdownObj, setDropdownObj] = useState({label: '--select--', id: '--select--'});
    const [masterCompanyList, setMasterCompanyList] = useState([{label: '--select--', id: '--select--'}]);
    // initialize state for num of pages 
    const [pages, setPages] = useState(0);
    // initialize state for total entries
    const [totalEntries, setTotalEntries] = useState(0);
    // initialize ref for params for pagination request
    const pageParams = useRef({});
    // initialize ref for num to page
    const numToPage = useRef(10);
    // initialize state for snackbar 
    const [showSnackbar, setShowSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarColor, setSnackbarColor] = useState('info');
    

    // function wrapper to pass row component to datatable
    const RowComponent = (row, count, tableHeader,stickyEnabled) =>{
        return( 
            <>
                <TransactionDataRow row={row} count={count} tableHeader={tableHeader} stickyEnabled={stickyEnabled}/>
            </>
        );
    } 

    // function to set snackbar state
    const snackbarAlert = (show, message, color) => {
        setSnackbarMessage(snackbarMessage => snackbarMessage = message);
        setSnackbarColor(snackbarColor => snackbarColor = color);
        setShowSnackbar(showSnackbar => showSnackbar = show);
    }

    const getRequestParams = (pageNum) => {
        let params = {
            mastercompanyid: masterCompanyObj['id'], 
            startdate: moment(startDate).format('YYYY-MM-DD'), 
            enddate: moment(endDate).format('YYYY-MM-DD'), 
            numToPage: numToPage.current, 
            pageNum: pageNum, 
        }
        // validate inputs by nullifying those that are not filtering table 
        if (subCompanyInput != 'All'){
            params['companyid'] = subCompanyInput;
        }

        if (feeCategorySelected != 'All'){
            params['feecategorydescription'] = feeCategorySelected;
        }

        if (productType != 'All'){
            params['producttypedescription'] = productType;
        }

        if (transactionLow != ''){
            params['transactionlow'] = removeStrCommas(transactionLow);
        }

        if (transactionHigh != ''){
            params['transactionhigh'] = removeStrCommas(transactionHigh);
        }

        if (accountInput != ''){
            params['accountid'] = accountInput; 
        }

        if (transactionDescription != ''){
            params['merchantdescription'] = transactionDescription;
        }

        return params; 
    }

    // promise to get data for excel export
    const getTransactionDataExcel = () => {
        return new Promise((resolve, reject) => {
            // get params from pageParams and without pageNum,numToPage,sortColumn and sortOrder
            let params = {}; 
            Object.keys(pageParams.current).map(el => {
                if (el != 'pageNum' && el != 'numToPage' && el != 'sortColumn' && el != 'sortOrder'){
                    params[el] = pageParams.current[el];
                }
            });
            // make request to /aggregates/transaction/excel endpoint to create xlsx files and get presigned urls
            GET('/aggregates/transactions/excel', params).then(res =>{
                console.log(res);
                resolve(res);
            }).catch(err => {
                console.log(err); 
                // if 512 error is thrown show message to limit export amount 
                let MAX_TRANS = parseInt(process.env.REACT_APP_MAX_TRANSACTION_EXPORT); 
                if (err.response.status === 512){
                    snackbarAlert(true, 'Error: Please limit export to ' + MAX_TRANS.toLocaleString() + ' transactions.', 'error');
                }
                else {
                    snackbarAlert(true, 'Error retrieving data.', 'error');
                }
                reject(err);
            }); 
        });        
    }

    // promise to make get request for search transaction data 
    const getTransactionDataSearch = (params) => {
        setShowSpinner(showSpinner => showSpinner = true);
        return new Promise ((resolve, reject) => {
            console.log(params);
            // use GET function to make request
            GET('/aggregates/transactions/filter', params).then(res => {
                // set state for table 
                setDataList(dataList => dataList = res['data']['TransactionData']);
                setTableHeader(tableHeader => tableHeader = res['data']['TransactionCols']);
                setPages(pages => pages = res['data']['TransactionPages']);
                setTotalEntries(pages => pages = res['data']['TransactionDataTotalLength']);
                setSubCompanyList(subCompanyList => subCompanyList = ['All', ...res['data']['SubCompanyList']]);
                // default filter parameters
                setFeeCategorySelected(feeCategorySelected => feeCategorySelected = 'All');
                setProductType(productType => productType = 'All');
                setSubCompanyInput(subCompanyInput => subCompanyInput = 'All');
                setAccountInput(accountInput => accountInput = '');
                setTransactionDescription(transactionDescription => transactionDescription = '');
                setTransactionHigh(transactionHigh => transactionHigh = '');
                setTransactionLow(transactionLow => transactionLow = '');
                // set params for pagination request
                pageParams.current = params; 
                // hide spinner
                setShowSpinner(showSpinner => showSpinner = false);
                // resolve on success
                resolve(res);
            }).catch(err => {
                snackbarAlert(true, 'Error retrieving data.', 'error');
                // hide spinner
                setShowSpinner(showSpinner => showSpinner = false);
                reject(err);
            });
        });
    }

    // promise to make get request for filtered transaction data 
    const getTransactionDataFilter = (params) => {
        setShowSpinner(showSpinner => showSpinner = true);
        return new Promise ((resolve, reject) => {
            console.log(params);
            // use GET function to make request
            GET('/aggregates/transactions/filter', params, 'transactions').then(res => {
                // set state for table 
                setDataList(dataList => dataList = res['data']['TransactionData']);
                setTableHeader(tableHeader => tableHeader = res['data']['TransactionCols']);
                setPages(pages => pages = res['data']['TransactionPages']);
                setTotalEntries(pages => pages = res['data']['TransactionDataTotalLength']);
                setSubCompanyList(subCompanyList => subCompanyList = ['All', ...res['data']['SubCompanyList']]);
                setFeeCategoryList(feeCategoryList => feeCategoryList = ['All', ...res['data']['FeeCategoryList']]);
                // set params for pagination request
                pageParams.current = params; 
                // hide spinner
                setShowSpinner(showSpinner => showSpinner = false);
                // resolve on success
                resolve(res);
            }).catch(err => {
                snackbarAlert(true, 'Error retrieving data.', 'error');
                // hide spinner
                setShowSpinner(showSpinner => showSpinner = false);
                reject(err);
            });
        });
    }

    // get data for dropdowns 
    const getMasterCompanyData = () => {
        return new Promise ((resolve, reject) => {
            GET('/aggregates/transactions/transactionPage', {}).then(res => {
                // set state
                setMasterCompanyList(masterCompanyList => masterCompanyList = [{label: '--select--', id: '--select--'}, ...res['data']['MasterCompanyData']]);
                setProductTypeList(productTypeList => productTypeList = ['All', ...res['data']['ProductTypeList']]);
                setTableHeader(tableHeader => tableHeader = res['data']['TransactionCols']);
                setFeeCategoryList(feeCategoryList => feeCategoryList = ['All', ...res['data']['FeeCategoryList']]); 
                // set selected state if not present in list
                if (!isNullOrUndefined(transactionDetails)) {
                    let temp = transactionDetails; 
                    if (!['All', ...res['data']['FeeCategoryList']].includes(temp['feecategorydescription'])) {
                        temp['feecategorydescription'] = 'All'; 
                        setFeeCategorySelected('All'); 
                    }
                    if (!['All', ...res['data']['ProductTypeList']].includes(temp['producttypedescription'])) {
                        temp['producttypedescription'] = 'All'; 
                        setProductType('All'); 
                    }
                }
                // resolve on success
                resolve(res);
            }).catch(err => {
                reject(err);
            });
        });
    }

    const onSearchSubmit = () => {
        setDropdownObj(masterCompanyObj);
        let params = {
            mastercompanyid: masterCompanyObj['id'], 
            startdate: moment(startDate).format('YYYY-MM-DD'), 
            enddate: moment(endDate).format('YYYY-MM-DD'), 
            numToPage: numToPage.current, 
            pageNum: 1, 
        }
        // get transaction data from params 
        getTransactionDataSearch(params).then(res => {
            console.log(res);
        }).catch(err => {
            console.log(err);
        });      
    }

    const onFilterSubmit = (resetParams) => {
        // get validated params 
        let params = resetParams || getRequestParams(1);
        // get transaction data from params 
        getTransactionDataFilter(params).then(res => {
            console.log(res);
        }).catch(err => {
            console.log(err);
        }); 
    }

    const onPagination = (page,sortColumn,sortOrder) => {
        return new Promise((resolve, reject) => {
            // use pageParams to make request 
            let params = pageParams.current;
            params['pageNum'] = page; 
            params['sortColumn'] = sortColumn;
            params['sortOrder'] = sortOrder;
            // get transaction data from params 
            getTransactionDataFilter(params).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            }); 
        });
    }

    const loadInitialData = () => {
        if (!(isNullOrUndefined(transactionDetails) || isNullOrUndefined(transactionDetails['periodid']) 
        || _.isEqual(transactionDetails, {}))){
            // set start date and end date from company info if it is present
            let year = parseInt(transactionDetails['periodid'].slice(0, 4));
            let month = parseInt(transactionDetails['periodid'].slice(4, transactionDetails['periodid'].length));
            // first day of month specified by periodid
            let tempStart = new Date(year, month-1, 1);
            setStartDate(startDate => startDate = tempStart);
            // last day of month specified by periodid
            let tempEnd = new Date(year, month, 0);
            setEndDate(endDate => endDate = tempEnd);
            // set sub company id 
            setSubCompanyInput(subCompanyInput => subCompanyInput = transactionDetails['companyid']);
            setSubCompanyList(subCompanyList => subCompanyList = ['All', transactionDetails['companyid']]);
            // set fee category 
            setFeeCategorySelected(feeCategorySelected => feeCategorySelected = transactionDetails['feecategorydescription']);
            setFeeCategoryList(feeCategoryList => feeCategoryList = ['All', transactionDetails['feecategorydescription']]);
            // set product type
            setProductType(productType => productType = transactionDetails['producttypedescription']); 
            setProductTypeList(productTypeList => productTypeList = ['All', transactionDetails['producttypedescription']])
            // set master company and obj
            setMasterCompany(masterCompany => masterCompany = company);
            setMasterCompanyObj(masterCompanyObj => masterCompanyObj = {'label': company, 'id': companyInfo['mastercompanyid']});
            setDropdownObj(masterCompanyObj => masterCompanyObj = {'label': company, 'id': companyInfo['mastercompanyid']});
            // get master company list for dropdown
            getMasterCompanyData().then(res => {
                console.log(res);
                // set params for getting transaction data 
                let params = {
                    mastercompanyid: companyInfo['mastercompanyid'], 
                    startdate: moment(tempStart).format('YYYY-MM-DD'), 
                    enddate: moment(tempEnd).format('YYYY-MM-DD'), 
                    companyid: transactionDetails['companyid'], 
                    feecategorydescription: transactionDetails['feecategorydescription'], 
                    producttypedescription: transactionDetails['producttypedescription'], 
                    numToPage: numToPage.current, 
                    pageNum: 1, 
                }
                if (params['feecategorydescription'] === 'All') {
                    delete params['feecategorydescription']; 
                }
                if (params['producttypedescription'] === 'All') {
                    delete params['producttypedescription']; 
                }
                console.log('PARAMS2: ', params); 
                // get transaction data 
                return getTransactionDataFilter(params);
            }).then(res => {
                console.log(res);
            }).catch(err => {
                console.log(err);
            });
        }
        // on render when page not accessed by drilldown
        else{
            getMasterCompanyData().then(res => {
                console.log(res);
            }).catch(err => {
                console.log(err);
            });
        }
    }
    // useEffect to run on initial render
    useEffect(() => {
        // set search params and filters from transaction data if present (page is clicked on details drilldown)
        loadInitialData();
    }, []); 

    // object to pass variables to PageContext
    const settings = {
        showSnackbar, 
        setShowSnackbar,
        snackbarMessage, 
        snackbarColor, 
    };

    //reset functionality 
    const resetToDefault = () => {
        let year = parseInt(transactionDetails['periodid'].slice(0, 4));
        let month = parseInt(transactionDetails['periodid'].slice(4, transactionDetails['periodid'].length));
        // first day of month specified by periodid
        let tempStart = new Date(year, month-1, 1);
        setStartDate(tempStart);
        // last day of month specified by periodid
        let tempEnd = new Date(year, month, 0);
        setEndDate(tempEnd);
        setMasterCompanyObj(masterCompanyObj => masterCompanyObj = {'label': company, 'id': companyInfo['mastercompanyid']});
        resetToDefaultFilters();
        loadInitialData();
        
    }

    const enableResetAll = () => {
        // set year andd month
        let year, month; 
        if (isNullOrUndefined(transactionDetails) || isNullOrUndefined(transactionDetails['periodid']) 
        || _.isEqual(transactionDetails, {}) ){
            let today = new Date(); 
            year = today.getFullYear().toString(); 
            month = (today.getMonth() + 1).toString();
        }
        else {
            year = parseInt(transactionDetails['periodid'].slice(0, 4));
            month = parseInt(transactionDetails['periodid'].slice(4, transactionDetails['periodid'].length));
        }
        // first day of month specified by periodid
        let tempStart = new Date(year, month-1, 1);
        // last day of month specified by periodid
        let tempEnd = new Date(year, month, 0);
        if(enableResetAllFilters() ||startDate.toString() !== tempStart.toString() || endDate.toString() !== tempEnd.toString() || masterCompanyObj.label !== company || masterCompanyObj.id !== companyInfo['mastercompanyid']
        ){
            return true;
        }
        return false;
    }

    const resetToDefaultFilters = () => {
        let feeCategory = 'All';
        let product = 'All'; 
        if(masterCompanyObj.id == companyInfo['mastercompanyid']){  
            setSubCompanyInput(transactionDetails['companyid']);
            // check that fee category exists in list 
            if (!isNullOrUndefined(feeCategoryList) && !feeCategoryList.includes(transactionDetails['feecategorydescription'])) {
                setFeeCategorySelected('All'); 
                feeCategory = 'All'; 
            }
            else {
                setFeeCategorySelected(transactionDetails['feecategorydescription']);
                feeCategory = transactionDetails['feecategorydescription']; 
            }
            // check that product type exists in list 
            let product; 
            if (!isNullOrUndefined(productTypeList) && !productTypeList.includes(transactionDetails['producttypedescription'])) {
                setProductType('All'); 
                product = 'All'
            }
            else {
                setProductType(transactionDetails['producttypedescription']); 
                product = transactionDetails['producttypedescription']; 
            }   
        } else {
            setFeeCategorySelected('All');
            setSubCompanyInput('All');
            setProductType('All'); 
        }
        setAccountInput('');
        setTransactionDescription('');
        setTransactionHigh('');
        setTransactionLow('');
        let params = {
            mastercompanyid: masterCompanyObj['id'], 
            startdate: moment(startDate).format('YYYY-MM-DD'), 
            enddate: moment(endDate).format('YYYY-MM-DD'), 
            numToPage: numToPage.current, 
            pageNum: 1,
        }
        if(masterCompanyObj.id == companyInfo['mastercompanyid']) {
            // validate inputs by nullifying those that are not filtering table 
            params['companyid'] = transactionDetails['companyid'];

            if (feeCategory !== 'All'){
                params['feecategorydescription'] = transactionDetails['feecategorydescription'];
            }

            if (product !== 'All'){
                params['producttypedescription'] = transactionDetails['producttypedescription'];
            }
        }

        onFilterSubmit(params);
    }

    const enableResetAllFilters = () => {
        if(dropdownObj.id == companyInfo['mastercompanyid']) {
            if(feeCategorySelected !== transactionDetails['feecategorydescription'] || subCompanyInput !== transactionDetails['companyid']
                || accountInput !== '' || productType !== transactionDetails['producttypedescription'] ||
                transactionDescription !== '' || transactionHigh !== '' || transactionLow !== ''
            ) {
                return true;
            }
        } else {
            if(feeCategorySelected !== 'All' || subCompanyInput !== 'All'
                || accountInput !== '' || productType !== 'All' ||
                transactionDescription !== '' || transactionHigh !== '' || transactionLow !== ''
            ) {
                return true;
            }
        }
        
        return false;
    }
    
    const enableSearch = () => {
        // set year andd month
        let year, month; 
        if (isNullOrUndefined(transactionDetails) || isNullOrUndefined(transactionDetails['periodid']) 
        || _.isEqual(transactionDetails, {}) ){
            let today = new Date(); 
            year = today.getFullYear().toString(); 
            month = (today.getMonth() + 1).toString();
        }
        else {
            year = parseInt(transactionDetails['periodid'].slice(0, 4));
            month = parseInt(transactionDetails['periodid'].slice(4, transactionDetails['periodid'].length));
        }
        // first day of month specified by periodid
        let tempStart = new Date(year, month-1, 1);
        // last day of month specified by periodid
        let tempEnd = new Date(year, month, 0);
        if(startDate.toString() !== tempStart.toString() || endDate.toString() !== tempEnd.toString() || masterCompanyObj.label !== company || masterCompanyObj.id !== companyInfo['mastercompanyid']
        ){
            return true;
        }
        return false;
    }
    

    return (
        <div class='summary-page'>
            {/* wrap children so they can access PageContext variables */}
            <PageContext.Provider value={ settings }>
                {/* header and navslider present on ever screen */}
                <HeaderBanner />
                {/* breadcrumbs */}
                <div className="pt-1 ms-3">
                    <PageBreadcrumbs />
                </div>
                {/* snackbar component for alerts */}
                <SnackbarAlert />
                <div className="container-fluid d-flex flex-column">
                    <div className="d-flex flex-column flex-grow-1 p-2">
                        <div className="mb-1" style={{ borderRadius: "12px", background: "white" }}>
                            <div className="d-flex p-3 align-items-center gap-3" style={{flexWrap:'wrap'}}>
                                <div>
                                    <AutoCompleteInputWithOptions tag={process.env.REACT_APP_MASTER_COMPANY_ID_TAG}  obj={masterCompanyObj} setObj={setMasterCompanyObj} list={masterCompanyList} />
                                </div>
                                <div>
                                    <DatePicker tag='Start Date' value={startDate} setValue={setStartDate} disable={endDate} indicator={1}/>
                                </div>
                                <div>
                                    <DatePicker tag='End Date' value={endDate} setValue={setEndDate} disable={startDate} indicator={2}/>
                                </div>
                                <div className="pe-3 align-self-center text-decoration-underline" style={{ color: `${enableResetAll() ? '#0295BE' : '#BDBDBD'}`, cursor: 'pointer', fontFamily: 'Roboto medium' }} onClick={() => enableResetAll() ? resetToDefault() : null}>
                                    Reset All
                                </div>
                                <div>
                                    <ButtonComponent 
                                        disabled={!enableSearch()}
                                        border={'#3D3D3D 1px solid'} background={'#fff'} color={'#3D3D3D'} tag={'Search'} onButtonClick={() => onSearchSubmit()}  
                                        disabledBorder={'#BDBDBD 1px solid'} disabledBackground={'#D6D6D6'} disabledColor={'#BDBDBD'}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="flex-grow-1 mt-1">
                            <div style={{ background: "white" ,borderRadius: "12px"}} >
                                <div className="d-flex p-3 pb-2 align-items-center">
                                    <Typography sx={{fontFamily:'Roboto medium, Helvetica, Arial, sans-serif',fontWeight:'500',fontSize:'12px',lineHeight:'14.06px'}}>
                                        Filter Results Between {moment(startDate).format('MM-DD-YYYY')} and {moment(endDate).format('MM-DD-YYYY')}
                                    </Typography>
                                </div>
                                {/* mid label for filtering results between start date and end date */}
                                <div className="d-flex p-2 ps-3 pe-3 align-items-center gap-3" style={{flexWrap:'wrap'}}>
                                    <div>
                                        <PageDropdown tag='Fee Category' value={feeCategorySelected} setValue={setFeeCategorySelected} list={feeCategoryList} width={'8em'}/>
                                    </div>
                                    <div>
                                        <AutoCompleteInput tag='Company ID' value={subCompanyInput} setValue={setSubCompanyInput} list={subCompanyList} width={'7em'}/>
                                    </div>
                                    <div>
                                        <PageInput tag='Account' value={accountInput} setValue={setAccountInput} width={'12em'}/>
                                    </div>
                                    <div>
                                        {/* <PageDropdown tag='Product Type' value={productType} setValue={setProductType} list={productTypeList} width={'7em'} /> */}
                                        <PageInput tag='Merch Desc' value={transactionDescription} setValue={setTransactionDescription} width={'12em'}/>
                                    </div>
                                </div>
                                <div className="d-flex p-2 ps-3 pe-3 align-items-center gap-3" style={{flexWrap:'wrap'}}>
                                    <div>
                                        <PageInput tag='Trans Amt (>)' value={transactionLow} setValue={setTransactionLow} width={'12em'}/>
                                    </div>
                                    <div>
                                        <PageInput tag='Trans Amt (<)' value={transactionHigh} setValue={setTransactionHigh} width={'12em'}/>
                                    </div>
                                    <div>
                                        {/* <PageInput tag='Merch Desc' value={transactionDescription} setValue={setTransactionDescription} width={'12em'}/> */}
                                    </div>
                                    <div className="pe-3 align-self-center text-decoration-underline" style={{ color: `${enableResetAllFilters() ? '#0295BE' : '#BDBDBD'}`, cursor: 'pointer', fontFamily: 'Roboto medium' }} onClick={() => enableResetAllFilters() ? resetToDefaultFilters() : null}>
                                            Reset All
                                    </div>
                                    <div className="d-flex align-items-center gap-1">
                                        <ButtonComponent 
                                            disabled={!enableResetAllFilters()}
                                            tag='Filter' border={'#3D3D3D 1px solid'} background={'#fff'} color={'#3D3D3D'}  onButtonClick={()=>onFilterSubmit()}
                                            disabledBorder={'#BDBDBD 1px solid'} disabledBackground={'white'} disabledColor={'#BDBDBD'}
                                        />
                                        <ExportS3ExcelButton tag={'transaction-details-' + masterCompanyObj['label'].slice(0, 10)} getData={getTransactionDataExcel}/>
                                    </div>
                                </div>
                                <div>
                                    {/* data table to show filtered transaction object array */}
                                    <ApiDataTable RowComponent={RowComponent} tableHeader={tableHeader} dataList={dataList} numOfPages={pages} numToPage={numToPage.current} totalDatalistLength={totalEntries} showSpinner={showSpinner} setShowSpinner={setShowSpinner} skeletonHeight={'320px'} onPagination={onPagination} pageParams={pageParams} stickyFirstColumnEnabled={true}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Footer cssClassName="footer-main-comp"/>
            </PageContext.Provider>
        </div> 
    );
}

export default TransactionDetailsPage;